import { render, staticRenderFns } from "./NovoEmail.vue?vue&type=template&id=4eb09462"
import script from "./NovoEmail.vue?vue&type=script&lang=js"
export * from "./NovoEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports